<template>
  <header class="header-container ps-4">
    <img src="@/assets/logo.svg" alt="Logo" loading="lazy" />

    <div class="group-icons">
      <icon name="mdi:facebook" />
      <icon name="mdi:instagram" />
      <icon name="mdi:linkedin" />
    </div>

    <div class="d-flex align-center">
      <icon name="mdi:help-circle-outline" />
      <p class="ml-2">Suporte</p>
    </div>
  </header>
</template>

<script lang="ts" setup>

</script>

<style lang="scss" scoped>
.header-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 70px;

  .group-icons {
    display: flex;
    align-items: center;
    gap: 24px
  }

  @media screen and (max-width: 768px) {
    .group-icons {
      gap: 8px;
    }
  }
}
</style>
